import type { SearchQueryParams, SearchQueryResponse } from '../types';
import { useInfiniteQuery } from '@tanstack/react-query';
import { APP_CONSTANTS } from '~/common/explicit-exports';
import FetchPromise from '~/agent/fetch-promise';
import HttpUtils from '~/agent/http-utils';
import { LEARNER_SEARCH_ROOT_URL } from '../constants';

const getSearchResults =
  (queryParams: SearchQueryParams) =>
  ({ pageParam = 0 }): Promise<SearchQueryResponse> => {
    const offset = pageParam ?? queryParams?.offset ?? 0;
    const queryData = { ...queryParams, offset, query: queryParams.query || '' };

    return FetchPromise.get(
      HttpUtils.buildUriWithQueryString(`${LEARNER_SEARCH_ROOT_URL}`, {
        ...queryData,
      }),
    );
  };

export const useLearnerSearchResults = (queryParams: SearchQueryParams, isEnabled: boolean = true) =>
  useInfiniteQuery<SearchQueryResponse, JQuery.jqXHR>(
    ['learner-search-results', queryParams],
    getSearchResults(queryParams),
    {
      enabled: isEnabled,
      getNextPageParam: (lastPage) =>
        lastPage.total === APP_CONSTANTS.LEARNER_SEARCH.SEARCH_RESULTS_LIMIT ? lastPage.offset : undefined,
    },
  );
